module.exports = __webpack_public_path__ + "img/github-login.ff8b1bab.svg";